import React from 'react';
import TemplateVariableMapping from '../components/TemplateVariableMapping';
import { useAuth } from '../contexts/AuthContext';

export default function TemplateMapping() {
  const { user } = useAuth();

  // Debug: verificar se a página está sendo renderizada
  console.log('TemplateMapping page rendered');
  console.log('User:', user);
  console.log('User role:', user?.role);
  console.log('Client ID:', user?.client_id);

  return (
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Mapeamento de Variáveis dos Templates</h1>
        <p className="text-muted-foreground mt-2">
          Configure como as variáveis dos templates da Meta (&#123;&#123;1&#125;&#125;, &#123;&#123;2&#125;&#125;, etc.) devem ser mapeadas para as colunas do banco de dados.
        </p>
        <div className="mt-4 p-4 bg-blue-50 rounded-lg">
          <p className="text-sm text-blue-800">
            <strong>Debug Info:</strong> User Role: {user?.role || 'N/A'}, Client ID: {user?.client_id || 'N/A'}
          </p>
        </div>
      </div>

      <TemplateVariableMapping clientId={user?.client_id} />
    </div>
  );
}
